import request from "./request";

const PracticalService = {
    GetAll: async (id, context, signal) => {
        return await request.sendRequest(`/practical/all/${id}`, context.token, signal);
    },
    BulkSave: async (payload, context, signal) => {
        return await request.sendPostRequest(`/practical/bulk`, payload, context, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/practical`, payload, context, signal);
    },
    SaveScore: async (payload, context, signal) => {
        return await request.sendPostRequest(`/practical/score`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/practical/${id}`, context.token);
    },
};

export default PracticalService;
